import * as d3 from "d3";
import {
    colonAnnotation, createTooltip,
    fw_progressive_1way,
     inrFormatterV2,
    make_y_gridlines,
    responsivefy, wrapsword,
} from '../functions'

export default function (chart, divId, vizName,resData, filterParam, gridflag) {
    /*Imp Note:
        1. Graph col must be end with '#' (like: DevLastWkRev%#).
        2. which metric will display the graph same number to be put the graph also.
        ie. if we want to print the graph metric3, so graph also be graph3.
    */
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName;
    // console.log("table bar", url)
    // axios.post(url, filterParam).then(res => {
        let data = resData

        console.log("reportHeaderColumnDpWordwrap",chart.reportHeaderColumnDpWordwrap);
        const jsonData=chart.reportHeaderColumnDpWordwrap;
        const vebdorname=jsonData.wordwrap['table heading'];
        const vendoraddres=jsonData.wordwrap['table data'];
        console.log("vebdorname",vebdorname);
        console.log("vendoraddres",vendoraddres);
        // Filter null and undefined values from the data
        //let filteredData = Object.entries(data[0]).reduce((a,[k,v]) => (v == null ? a: (a[k]=v, a) ), {})

        // Setup the scale for the values for display, use abs max as max value
        var titleMap = chart.reportHeaderColumnDp;
        console.log("titleMap:", titleMap)
        // get the keys from filtered data which filtered null, undefined columns

        var dataTitlesOrg = d3.values(titleMap)
        var dataTitles = dataTitlesOrg.filter(function (item) {
            return !item.startsWith('graph')
        })
        /* to make soting fun work properly based on data dim names,
        create a title mapping between dp names and backend dim names */
        var titles = d3.keys(titleMap)
        var sortAscending = true;

        //Table reports ploting to times need to revisit
        d3.select(divId).select("table").remove();
        //  d3.select(divId, "table").remove();
        var table = d3.select(divId).append("table").style("width", "100%");
        // Create table header
        var headers = table.append('thead')
            .append('tr')
            .selectAll('th')
            .data(titles)
            .enter()
            .append('th')
            .attr("class", 'tbc-header')
            .style("background", "#333")
            .text(function (d) {
                return wrapsword(d,vebdorname)
            })
            .style("text-align", "center")
            .style("color", "#fff")
            .style("white-space", "pre")
            .style("line-height", "1")
            .style("width", '0px')
            .on('click', function (d) {
                headers.attr('class', 'tbc-header')
                if (sortAscending) {
                    let graphMetric = titleMap[d]
                    if (d.endsWith('#')) {
                        graphMetric = titleMap[d].replace('graph', 'metric')
                    }
                    tr.sort(function (a, b) {
                        return b[graphMetric] < a[graphMetric] ? 1 : -1;
                    });
                    sortAscending = false;
                    this.className = 'tbc-aes';
                    console.log("sort if asc")
                } else {
                    let graphMetric = titleMap[d]
                    if (d.endsWith('#')) {
                        graphMetric = titleMap[d].replace('graph', 'metric')
                    }
                    tr.sort(function (a, b) {
                        return b[graphMetric] > a[graphMetric] ? 1 : -1;
                    });
                    sortAscending = true;
                    this.className = 'tbc-des';
                    console.log("sort else desc")
                }
            });
        // Create a table with rows and bind a data row to each table row
        var tr = table.selectAll('tr.g').data(data).enter().append('tr');
        //selectAll selects the already available tr element so it skips the data first row
        //https://stackoverflow.com/questions/19182775/d3-data-skipping-the-first-row-of-data
        tr.selectAll('td')
            .data(function (d) {
                return dataTitles.map(function (k) {
                    return {'value': d[k], 'name': k};
                });
            })
            .enter()
            .append('td')
            .attr("class", "reptd")
            .attr('data-th', (d) => {
                return d.name;
            })
            // .text((d) =>{ return inrFormatter(d.value) })
            .text((d) => {
                return typeof d.value != 'number' ? d.value : inrFormatterV2(d.value,chart.data.menuId)
            })
            .style("text-align", (d) => {
                return d.name.startsWith('metric') ? 'right' : 'left'
            })
            .style("color", (d) => {
                if (d.name.startsWith('metric')) {
                    return d.value >= 0 ? chart.vizSpecific4 : chart.vizSpecific5
                }
            });

        for (var key in titleMap) {
            if (titleMap[key].startsWith('graph')) {
                var val = titleMap[key];
                var valMetric = val.replace('graph', 'metric')
                var graph = tr.append("td").attr("class", "tbc-" + val).attr("width", 2 * chart.width)
                graph.append("body").attr("class", "container").append("body").attr("class", "negative" + val.replace('graph', ''))
                graph.append("body").attr("class", "container").append("body").attr("class", "positive" + val.replace('graph', ''))
                var x1Scale = d3.scaleLinear()
                    .domain([0, d3.max(data, (d) => {
                        return Math.abs(d[valMetric]);
                    })])
                    .range(["0", "100%"]);
                tr.select("body.negative" + val.replace('graph', ''))
                    .style("width", "0%")
                    .transition()
                    .duration(500)
                    .style("width", (d) => {
                        return d[valMetric] > 0 ? "0%" : x1Scale(Math.abs(d[valMetric]));
                    })
                    .style("float", "right")
                    .style("background-color", chart.vizSpecific5);

                tr.select("body.positive" + val.replace('graph', ''))
                    .style("width", "0%")
                    .transition()
                    .duration(500)
                    .style("width", (d) => {
                        return d[valMetric] > 0 ? x1Scale(d[valMetric]) : "0%";
                    })
                    .style("background-color", chart.vizSpecific4);
            }
        }

        var size = chart.axisFontSize
        var fontSize = size + "px"
        var fontColor = chart.axisFontColor
        var axisLabelFontSize = chart.axisLabelFontSize + "px";

        //var tempVar = chart.tempVar

        // set the ranges
        var x1 = d3.scaleBand().rangeRound([0, chart.width]).padding(0.1);
        var y1Scale = d3.scaleLinear().rangeRound([chart.height, 0]);
        var y2Scale = d3.scaleLinear().rangeRound([chart.height, 0]);
        // define the axis
        var x1AxisLabel = d3.axisBottom().scale(x1);
        var y1AxisLabel = d3.axisLeft().scale(y1Scale).tickFormat(function (d){return inrFormatterV2(d,chart.data.menuId)}).ticks(5);
        var y2AxisLabel = d3.axisRight().scale(y2Scale).tickFormat(function (d){return inrFormatterV2(d,chart.data.menuId)}).ticks(5);

        var metric1ColorScale = d3.scaleOrdinal().range(fw_progressive_1way);

        var valueline = d3.line()
            .x(function (d) {
                return x1(d.dim1_name) + 50;
            })
            .y(function (d) {
                return y2Scale(d.metric2);
            });

        var valueline1 = d3.line()
            .x(function (d) {
                return x1(d.dim1_name) + 50;
            })
            .y(function (d) {
                return y2Scale(d.metric3);
            });

        const tooltip = createTooltip(divId);


        // add the SVG element
        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId)
            .append("svg")
            .attr("width", chart.width + 2 * chart.margin.left + chart.margin.right)
            .attr("height", chart.height + 5 * chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .append("g")
            .attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");

        data.forEach(function (d) {
            d.metric1 = +d.metric1;
        });

        // scale range of the data
        x1.domain(data.map((d) => {
            return d.dim1_name
        }));
        y1Scale.domain([0, d3.max(data, (d) => {
            return d.metric1
        })]);
        y2Scale.domain([0, d3.max(data, function(d) {
            console.log("kiran metric2:", d.metric2);
            console.log("kiran metric3:", Math.max(d.metric2, d.metric3));
            return Math.max(d.metric2, d.metric3);
        })]);
        // add axis
        svg.append("g")
            .attr("class", "x axis")
            .attr("transform", "translate(0," + chart.height + ")")
            .call(x1AxisLabel)
            .selectAll("text")
            //.attr("class","axisL20")
            .style('font-size', axisLabelFontSize)
            .style("text-anchor", "end")
             .attr("x", "-0.5em")
             .attr("y", "0em")
            // .attr("dx", 0)
             .attr("transform", "rotate(-45)")
console.log('hello',chart.axisLabelDistance)

        svg.append('text')
            .attr('x', (chart.width / 2))
            .attr('y', chart.height+ chart.margin.top + chart.axisLabelDistance )
            //.style('fill', 'blue')
            .style("text-anchor", "middle")
            .style('fill', fontColor)
            .style('font-size', fontSize)
            .text(chart.x1AxisDisplayName)

        svg.append("g")
            .attr("class", "y axis")
            .call(y1AxisLabel)
            .style("font-size", axisLabelFontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', - chart.margin.left)
            .attr('x', 0 - (chart.height / 2) )
            .attr("dy", ".71em")
            .style("text-anchor", "middle")
            .style('fill', fontColor)
            .style('font-size', fontSize)
            .text(chart.y1AxisDisplayName)

        svg.append("g")
            .attr("class", "y axis")
            .attr("transform", "translate(" + chart.width + " ,0)")
            .call(y2AxisLabel)
            .style("font-size", axisLabelFontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('x', 0 - (chart.height / 2))
            .attr('y',  chart.width + chart.margin.right+ 20)
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .style('font-size', fontSize)
            .text(chart.y2AxisDisplayName)

        // Add bar chart
        svg.selectAll("bar")
            .data(data)
            .enter()
            .append("rect")
            .attr("class", "bar")
            .attr("x", (d) => {
                return x1(d.dim1_name)
            })
            .attr("width", x1.bandwidth())
            .attr("y", function (d) {
                return y1Scale(d.metric1)
            })
            .style("fill", (d) => {
                return metric1ColorScale(d.dim1_name)
            })
            .attr("height", (d) => {
                return chart.height - y1Scale(d.metric1)
            })
            .on("mouseover", function(d) {
                console.log(d3.event, d); // For debugging, log the event and data
                tooltip.onMouseOver(d, this, function(d) {
                    // Tooltip content callback
                    return chart.x1MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                        chart.y1MetricTooltip + colonAnnotation + inrFormatterV2(d.metric1,chart.data.menuId)
                });
            })
            .on('mousemove', function(event) {
                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
            })
            .on("mouseout", function() {
                // Hide the tooltip on mouse out
                tooltip.onMouseLeave();
            });

        //value top of the bar
        svg.selectAll('text.bar')
            .data(data)
            .enter().append('text')
            .attr('class', 'bar')
            .attr('text-anchor', 'middle')
            .attr('x', function (d) {
                return x1(d.dim1_name) + x1.bandwidth() / 2
            })
            .attr('y', function (d) {
                return y1Scale(d.metric1) - 5
            })
            .text((d) => {
                return inrFormatterV2(d.metric1,chart.data.menuId)
            })
            .attr('fill', 'black')
            .style('font-size', '30px')

        svg.append("path")        // Add the valueline2 path.
            .attr("class", "line")
            .style('fill', 'none')
            .style('stroke', 'black')
            .style("stroke-width", '8px')
            .attr("d", valueline(data));

        svg.selectAll("dot")
            .data(data)
            .enter()
            .append("circle")
            .attr("r", 10)
            .attr("cx", function (d) {
                return x1(d.dim1_name) + 50;
            })
            .attr("cy", function (d) {
                return y2Scale(d.metric2);
            })
            .style("fill", 'black')
            .on("mouseover", function(d) {
                tooltip.onMouseOver(d, this, function(d) {
                    // Tooltip content callback
                    return chart.x1MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                        chart.y2MetricTooltip + colonAnnotation + inrFormatterV2(d.metric2,chart.data.menuId)
                });  // Pass the event for positioning
            })
            .on('mousemove', function(event) {
                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
            })
            .on("mouseout", function() {
                // Hide the tooltip on mouse out
                tooltip.onMouseLeave();
            });

        svg.append("path")        // Add the valueline2 path.
            .attr("class", "line-dotted") // Define a new class for the dotted line
            .style('fill', 'none')
            .style('stroke', 'black')
            .style('stroke-dasharray', '8,8') // Set the stroke-dasharray to make it a dotted line
            .style("stroke-width", '8px') // Set the stroke width for the dotted line
            .attr("d", valueline1(data));

        svg.selectAll("dot")
            .data(data)
            .enter()
            .append("circle")
            .attr("r", 10)
            .attr("cx", function (d) {
                return x1(d.dim1_name) + 50;
            })
            .attr("cy", function (d) {
                return y2Scale(d.metric3);
            })
            .style("fill", 'black')
            .on("mouseover", function(d) {
                console.log(d3.event, d); // For debugging, log the event and data
                tooltip.onMouseOver(d, this, function(d) {
                    // Tooltip content callback
                    return chart.x1MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                        chart.y2MetricTooltip + colonAnnotation + inrFormatterV2(d.metric2,chart.data.menuId)
                });
            })
            .on('mousemove', function(event) {
                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
            })
            .on("mouseout", function() {
                // Hide the tooltip on mouse out
                tooltip.onMouseLeave();
            });

        if (gridflag == true) {
            // add the X gridlines
            /*svg.append("g")
                     .attr("class", "grid")
                     .attr("transform", "translate(0," + chart.height + ")")
                     .call(make_x_gridlines(x1Scale)
                     .tickSize(-chart.height)
                     .tickFormat("")
                )*/

            // add the Y gridlines
            svg.append("g")
                .attr("class", "grid")
                .call(make_y_gridlines(y1Scale)
                    .tickSize(-chart.width)
                    .tickFormat("")
                )
        }
        /*
            // gridlines in x axis function
            function make_x_gridlines() {
                return d3.axisBottom(x1Scale)
                    .ticks(5)
            }

            // gridlines in y axis function
            function make_y_gridlines() {
                return d3.axisLeft(y1Scale)
                    .ticks(5)
            }*/
        //     .on("mouseover", function(){
        //     tooltip.html(() =>{ return "d.dim1_name+ colonAnnotation+ inrFormatter(d.metric1)" })
        //         .style('top', d3.event.pageY - 10 + 'px')
        //         .style('left', d3.event.pageX + 10 + 'px')
        //         .style("opacity", 1);
        // });
        //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding
    // })
}
